import { connect } from 'react-redux';
import { getIsStatusSubmitting, getStatusUpdateError } from './selectors';
import { submitStatus, submitStatusFailureDismiss, } from './actions';
var mapStateToProps = function (state, props) { return ({
    error: getStatusUpdateError(state),
    isSubmitting: getIsStatusSubmitting(state),
}); };
var mapDispatchToProps = { submitStatus: submitStatus, submitStatusFailureDismiss: submitStatusFailureDismiss };
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=StatusEditPopup.container.js.map